<div fxLayout="column" class="gap-2 m-b-10">
    <div class="vstack">
        <div class="HeaderSet" *ngIf="HeaderSet"
             matTooltip="These are terms which were agreed at the time of Booking Confirmation, any changes in terms
                will be reflected in the Booking Summary section">
            <span class="editHead editHeadCursor" (click)="emptyRepoDetailsExpand = !emptyRepoDetailsExpand">
                Quotation
                <i class="flaticon-down-chevron" [ngClass]="emptyRepoDetailsExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="emptyRepoDetailsExpand">
            <div class="quotedate shadoo">
                <label>Booking Date: {{ currentDate | date:"dd MMM, yyyy" }}
                    <span
                        *ngIf="requestService.selectedRequest.status.dev_name != 'booking_confirmed' && emptyRepoQuoteService.type != 'confirm'"
                        class="quoteValidTill">(<b> Valid Till</b> : {{
                            emptyRepoQuoteService.baseQuote?.quote_valid_till | date:"dd MMM,yyyy" ??  '-' }})
                    </span>
                </label>
                <div style="display: flex; gap: 5px;">
                    <button
                        [matTooltip]="requestService.selectedRequest.status.dev_name == 'booking_confirmed'? 'Download Smart Contract':'Download Booking Details'"
                        class="editRequest downloadQuoteBtn" mat-icon-button (click)="downloadQuote(commercials)">
                        <i class="flaticon-download"></i>
                    </button>
                    <button [matTooltip]="'Send Smart Contract'" class="editRequest downloadQuoteBtn" mat-icon-button
                            *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'"
                            (click)="openSendQuoteConfirmationDialog(commercials?.id, 'empty_repo',
                            'Smart contract shared on email', 'booking')">
                        <i class="flaticon-email"></i>
                    </button>
                </div>
            </div>

            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="100" class="leftReview">
                    <div fxLayout="column" class="w-100 shadoo ">
                        <div class="locationBox">
                            <div class="rowSet ">
                                <span fxFlex="30" class="rowSetTitle">ON-HIRE LOCATION</span>
                                <div class="quoteItemsBox locBox">
                                    <div *ngFor="let commercials of commercials.quote_items">
                                        {{ commercials.container_size_type?.display }}
                                        :
                                        <ng-container *ngIf="commercials.pol_list!=null">
                                            <span class="location">{{
                                                    commercials.pol_list[0]?.name_display ??
                                                    '-'
                                                }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 1">{{ commercials.pol_list[1]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 2">{{ commercials.pol_list[2]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 3">{{ commercials.pol_list[3]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 4">{{ commercials.pol_list[4]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 5">{{ commercials.pol_list[5]?.name_display }}</span>
                                            <span class="additionalLoc" *ngIf="commercials.pol_list?.length > 6"
                                                  [matTooltipShowDelay]="400"
                                                  [matTooltip]="commercials.pol_list | tooltipList"
                                                  matTooltipClass="tooltip-list">{{
                                                    commercials.pol_list?.length > 6
                                                        ? "+" + (commercials.pol_list?.length - 6) + " more locations"
                                                        : commercials.pol_list?.length == 6
                                                            ? "+" + (commercials.pol_list?.length - 6) + " more locations" : ''
                                                }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="rowSet ">
                                <span fxFlex="30" class="rowSetTitle">OFF-HIRE LOCATION</span>
                                <div class=" quoteItemsBox locBox">
                                    <div *ngFor="let commercials of commercials.quote_items">
                                        {{ commercials.container_size_type?.display }}
                                        :
                                        <ng-container *ngIf="commercials.pod_list!=null">
                                            <span class="location">{{
                                                    commercials.pod_list[0]?.name_display ??
                                                    '-'
                                                }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 1">{{ commercials.pod_list[1]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 2">{{ commercials.pod_list[2]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 3">{{ commercials.pod_list[3]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 4">{{ commercials.pod_list[4]?.name_display }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 5">{{ commercials.pod_list[5]?.name_display }}</span>
                                            <span class="additionalLoc" *ngIf="commercials.pod_list?.length > 6"
                                                  [matTooltipShowDelay]="400"
                                                  [matTooltip]="commercials.pod_list | tooltipList"
                                                  matTooltipClass="tooltip-list">{{
                                                    commercials.pod_list?.length > 6
                                                        ? "+" + (commercials.pod_list?.length - 6) + " more locations" :
                                                        commercials.pod_list?.length == 6
                                                            ? "+" + (commercials.pod_list?.length - 6) + " more locations" : ''
                                                }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="commercialTable shadoo">
                        <span class="title">COMMERCIALS</span>
                        <div class="container">
                            <div class="labelSet" fxFlex="30">
                                <span class="titleL">Equipment</span>
                                <span class="label">Quantity</span>
                                <ng-container *ngFor="let quote of commercials.quote_items; let i = index">
                                    <ng-container *ngIf="i == 0">
                                        <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                                <span class="label">{{
                                                        charge.quote_charge.charge.print_name
                                                    }}</span>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <!-- <ng-container *ngFor="let charge of commercials.ad_hoc_charges, let i=index">
                                                <span class="label">{{
                                                        charge.quote_charge.charge.print_name
                                                    }}</span>
                                </ng-container> -->
                            </div>
                            <div fxFlex="67" class="valueSetBox">
                                <div class="valueSet" fxFlex="14.7em"
                                     *ngFor="let quote of commercials.quote_items | orderRequirements:
                                 'container_size_type':'display':'asc'; let i = index">
                                    <span class="valueL">
                                        {{ quote.container_size_type?.display }}
                                    </span>
                                    <span class="value"> {{ quote.quantity ?? '-' }}</span>
                                    <ng-container *ngIf="quote?.ad_hoc_charges?.length > 0">
                                        <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                            <span class="value">{{ charge.pay_amount }} {{
                                                    charge.pay_amount_currency
                                                }}</span>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!-- <div fxFlex="67" class="valueSetBox">
                                    <ng-container *ngFor="let charge of commercials.ad_hoc_charges, let i=index">
                                       <span class="value">{{ charge.pay_amount }} {{
                                               charge.pay_amount_currency
                                           }}</span>
                                   </ng-container>
                                </div> -->
                            </div>
                        </div>
                        <div class="container">
                            <div class="labelSet" fxFlex="30">
                                <span class="titleL">Job Based Charges</span>
                                <ng-container *ngFor="let charge of commercials.ad_hoc_charges, let i=index">
                                    <span class="label">{{
                                        charge.quote_charge.charge.print_name
                                        }}</span>
                                </ng-container>
                            </div>
                            <div fxFlex="67" class="valueSetBox">
                                <div class="valueSet" fxFlex="14.7em">
                                    <span class="valueL"> Amount</span>
                                  <ng-container *ngFor="let charge of commercials.ad_hoc_charges, let i=index">
                                      <span class="value">{{ charge.pay_amount }} {{
                                          charge.pay_amount_currency
                                          }}</span>
                                  </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="commercialTable shadoo">
                        <div class="vstack"
                             *ngIf="requestService.selectedRequest?.status.default_option_dev_name!='cold_leads'">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Comments/Attachments
                                </span>
                            </div>
                            <ng-container>
                                <div>
                                    <mat-tab-group animationDuration="1500ms">
                                        <mat-tab label="Comments">
                                            <logzy-quote-remarks fxLayout="row wrap">
                                            </logzy-quote-remarks>
                                        </mat-tab>
                                        <mat-tab label="Attachments">
                                            <div class="mnrList">
                                                <logzy-request-documents fxFlex="100"></logzy-request-documents>
                                            </div>
                                        </mat-tab>
                                    </mat-tab-group>
                                </div>
                            </ng-container>
                        </div>
                        <!--                        <div class="vstack ">-->
                        <!--                            <div class="HeaderSet">-->
                        <!--                                <span class="editHead editHeadCursor">-->
                        <!--                                    TERMS AND CONDITIONS-->
                        <!--                                </span>-->
                        <!--                            </div>-->
                        <!--                            <ng-container>-->
                        <!--                                <quill-view [content]="commercials.terms_and_condition_text" format="html" theme="snow"-->
                        <!--                                            style="max-width: 761px; min-height: 100px; overflow: auto;"></quill-view>-->
                        <!--                            </ng-container>-->
                        <!--                        </div>-->
                        <div class="vstack"
                             *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Booking Remarks
                                </span>
                            </div>
                            <ng-container>
                                <quill-view [content]="commercials.remarks" format="html" theme="snow"
                                            style="max-width: 761px; min-height: 100px; overflow: auto;"></quill-view>
                            </ng-container>
                        </div>
                        <ng-container>
                            <div fxFlex="100" class="btnb" fxLayout="row wrap">
                                <!--                                <button class="loadingBtn Save" mat-raised-button-->
                                <!--                                        (click)="editRequest()">-->
                                <!--                                    <span> Edit Booking </span>-->
                                <!--                                </button>-->
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vstack">
        <div class="HeaderSet" *ngIf="HeaderSet">
            <span class="editHead editHeadCursor" (click)="bookingDetailsExpand = !bookingDetailsExpand">
                Booking Summary
                <i class="flaticon-down-chevron" [ngClass]="bookingDetailsExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="bookingDetailsExpand">
            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="100" class="leftReview">
                    <div class="commercialTable shadoo">
                        <!-- <span class="title">COMMERCIALS</span> -->
                        <div class="container">
                            <div class="labelSet" fxFlex="30">
                                <span class="titleL">Terms</span>
                                <span class="label" [class.valueEditMaxHeight]="editQuantity">Quantity</span>
                                <span class="label" [class.valueEditMaxHeight]="editSizeType">Size Type</span>
                                <span class="label" [class.valueEditMaxHeight]="editLocation">POL</span>
                                <span class="label" [class.valueEditMaxHeight]="editLocation">POD</span>
                            </div>
                            <div fxFlex="67" class="valueSetBox">
                                <div class="valueSet" fxFlex="27.7em"
                                     *ngFor="let quote of bookingDetails?.requirements; let i = index">
                                    <span class="valueL">{{ quote.container_size_type?.display ?? '-'}}
                                    </span>

                                    <!-- Quantity -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editQuantity"
                                          fxLayout="row">
                                        <ng-container *ngIf="!quote.editQuantity">
                                            {{ quote.quantity ?? '-' }}
                                            <i class="flaticon-pencil" (click)="quote.editQuantity = true; edit =
                                            true; editQuantity=true"
                                               matTooltip="Edit Quantity"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editQuantity">
                                            <app-number-field [isEditable]="true" [placeholder]="'Quantity'"
                                                              class="w-100i"
                                                              [(ngModel)]="quote.quantity" [containerNum]="true"
                                                              [noDecimal]="true"
                                                              [maxlength]="4"
                                                              [minValue]="1"
                                                              [errors]="errorObj[quote.id]?.quantity">
                                            </app-number-field>
                                            <!-- <i class="flaticon-save" (click)="postBookingQuantity(quote)" matTooltip="Save Quantity"></i> -->
                                        </ng-container>
                                    </span>

                                    <!-- Size Type -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editSizeType"
                                          fxLayout="row">
                                        <ng-container *ngIf="!quote.editContainerSizeType">
                                            {{ quote.container_size_type?.display ?? '-' }}
                                            <i class="flaticon-pencil"
                                               (click)="quote.editContainerSizeType = true;editSizeType =true; edit =
                                                true"
                                               matTooltip="Edit Size Type"
                                            ></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editContainerSizeType">
                                            <app-mat-auto-search [isEditable]="true" fxFlex="100"
                                                                 class="containerType conditions" [searchIcon]="true"
                                                                 [(ngModel)]="quote.container_size_type"
                                                                 [idField]="null" displayField='display'
                                                                 [trim]="true"
                                                                 [clearable]="true"
                                                                 [listUrl]="containerSizeTypeUrl"
                                                                 [errors]="errorObj[quote.id]?.container_size_type">
                                            </app-mat-auto-search>
                                            <!-- <i class="flaticon-save" (click)="postContainerSizeType(quote)" matTooltip="Save size type"></i> -->
                                        </ng-container>
                                    </span>

                                    <!-- POL -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editLocation"
                                          fxLayout="row">
                                        <ng-container *ngIf="!quote.editPOL">
                                            <div fxLayout="row" class=" gap-1 " *ngIf="quote.pol_list!=null">
                                                <span class="location">{{
                                                        quote.pol_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                                <span class="location"
                                                      *ngIf="quote.pol_list?.length > 1"> |
                                                    {{ quote.pol_list[1]?.name_display }}</span>
                                                <span class="additionalLoc" *ngIf="quote.pol_list?.length > 2"
                                                      [matTooltipShowDelay]="400"
                                                      [matTooltip]="quote.pol_list | tooltipList"
                                                      matTooltipClass="tooltip-list">{{
                                                        quote.pol_list?.length > 2
                                                            ? "  +" + (quote.pol_list?.length - 2) + " more locations"
                                                            : quote.pol_list?.length == 2
                                                                ? "  +" + (quote.pol_list?.length - 2) + " more locations"
                                                                : ''
                                                    }}
                                                </span>
                                            </div>
                                            <i class="flaticon-pencil" (click)="quote.editPOL = true; quote.editPOD =
                                            true; edit = true;editLocation=true" matTooltip="Edit Locations"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editPOL">
                                            <app-mat-auto-search [(ngModel)]="quote.pol_list"
                                                                 [isEditable]="true"
                                                                 [idField]="null" displayField='name_display'
                                                                 [trim]="true"
                                                                 [multiple]="true"
                                                                 [defaultChip]="false" [clearable]="true"
                                                                 [closeOnSelect]="false"
                                                                 [clearSearchOnAdd]="true"
                                                                 [listUrl]="location_url" name="pods" fxLayout="column"
                                                                 class="w-100i locations"
                                                                 [errors]="errorObj.pol_list">
                                            </app-mat-auto-search>
                                            <!-- <i class="flaticon-save" (click)="postBookingLocation(quote)" matTooltip="Save Booking Location"></i> -->
                                        </ng-container>
                                    </span>

                                    <!-- POD -->
                                    <span class="value gap-1 justify-content-between"
                                          [class.valueEditMaxHeight]="editLocation" fxLayout="row">
                                        <ng-container *ngIf="!quote.editPOD">
                                            <div fxLayout="row" class=" gap-1 " *ngIf="quote.pod_list!=null">
                                                <span class="location">{{
                                                        quote.pod_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                                <span class="location"
                                                      *ngIf="quote.pod_list.length > 1"> | {{
                                                        quote.pod_list[1]?.name_display
                                                    }}</span>
                                                <span class="additionalLoc" *ngIf="quote.pod_list?.length > 2"
                                                      [matTooltipShowDelay]="400"
                                                      [matTooltip]="quote.pod_list | tooltipList"
                                                      matTooltipClass="tooltip-list">{{
                                                        quote.pod_list?.length > 2
                                                            ? "  +" + (quote.pod_list?.length - 2) + " more locations" :
                                                            quote.pod_list?.length == 2
                                                                ? "  +" + (quote.pod_list?.length - 2) + " more locations"
                                                                : ''
                                                    }}
                                                </span>
                                            </div>
                                            <!--                                            <i class="flaticon-pencil" (click)="quote.editPOD = true"></i>-->
                                        </ng-container>
                                        <ng-container *ngIf="quote.editPOD">
                                            <app-mat-auto-search [(ngModel)]="quote.pod_list"
                                                                 [isEditable]="true"
                                                                 [idField]="null" displayField='name_display'
                                                                 [trim]="true"
                                                                 [multiple]="true"
                                                                 [defaultChip]="false" [clearable]="true"
                                                                 [closeOnSelect]="false"
                                                                 [clearSearchOnAdd]="true"
                                                                 [listUrl]="location_url" name="pods" fxLayout="column"
                                                                 class="w-100i locations"
                                                                 [errors]="errorObj.pod_list">
                                            </app-mat-auto-search>
                                        </ng-container>
                                    </span>
                                    <div class="btnb" *ngIf="quote.editQuantity || quote.editPOL || quote.editPOD
                                    || quote.editContainerSizeType"
                                         style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                                        <button mat-raised-button (click)="saveRequirement(quote)" class="addBtn clickIt">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btnb" *ngIf="edit"
                             style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                            <button mat-raised-button (click)="reset()" class="Cancel">
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div fxLayout="column" class="w-100 shadoo ">
                        <span class="title">BOOKING CHARGES</span>
                        <logzy-booking-charges (reqContainers)="showContainers($event)"></logzy-booking-charges>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #ralItemTemplate let-item>
    <div class="ral-container">
        <div class="color-box" [style.background-color]="item?.HEX"></div>
        <div class="color">
            <span class="ral-code">{{ item?.RAL ?? '-' }}</span>
            <span class="color-name">{{ item?.name ?? '-' }}</span>
        </div>
    </div>
</ng-template>

<ng-template #ralLabelItemTemplate let-item>
    {{ item?.name ?? '-' }}
</ng-template>
